export function header() {
  const header = document.querySelector('.l-header_inner')
  window.addEventListener('scroll', () => {
    classToggle();
  })
  window.addEventListener('load', () => {
    classToggle();
  })

  const classToggle = () => {
    var scroll_y = window.scrollY;
    if(scroll_y > 0) {
      header.classList.add('is-active');
    } else {
      header.classList.remove('is-active');
    }
  }
}
